<template>
  <aside
    class="aviso-veracidad-card card border-0 shadow-sm p-3 rounded-lg"
    role="note"
    aria-label="Aviso de validación de especialidades médicas"
  >
    <div class="d-flex align-items-start">
      <font-awesome-icon
        icon="shield-halved"
        class="text-primary-base mr-3 mt-1 fa-lg flex-shrink-0"
      />
      <div>
        <header
          class="font-weight-bold text-dark-blue small mb-1 text-uppercase"
        >
          Validación de credenciales y transparencia
        </header>
        <p class="text-muted small mb-0 line-height-sm">
          AMII cuenta con un riguroso proceso de validación documental previo
          al registro. No obstante, instamos a los pacientes a verificar
          la pertinencia de las credenciales de su médico tratante. AMII no
          asume responsabilidad por perfiles que eludan los filtros o por
          especialidades no confirmadas. Puedes acceder al perfil público
          de cada especialista para conocer más información.
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'AvisoVeracidadEspecialidad',
};
</script>

<style lang="scss" scoped>
.aviso-veracidad-card {
  background-color: #f7fafc;
  border-left: 4px solid #00a896 !important;
}
.line-height-sm {
  line-height: 1.45;
}
</style>
